var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{staticClass:"dialog-active",attrs:{"id":"modal-show-qr-code","title":'QRCode: ' +  _vm.QRCodeTitle,"hide-footer":"","centered":""}},[_c('el-row',{staticClass:"pr-2 pl-2",attrs:{"gutter":10}},[_c('qr-code',{staticClass:"d-flex justify-content-center",attrs:{"text":_vm.qrCode}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }